import { useQuery } from '@tanstack/react-query';
import { useState } from 'react';
import { Card } from '../../../shared/components/ui/Card.js';
import { Input } from '../../../shared/components/ui/Input.js';
import { auditApi } from '../api.js';

export function AuditPage() {
  const [actionFilter, setActionFilter] = useState('');

  const auditQuery = useQuery({
    queryKey: ['audit', actionFilter],
    queryFn: () => auditApi.list({ ...(actionFilter && { action: actionFilter }), limit: 200 }),
  });

  return (
    <div className="p-6 space-y-6">
      <div className="flex items-center justify-between">
        <div>
          <h1 className="text-xl font-bold text-[#0f172a]">Auditoria</h1>
          <p className="text-sm text-[#64748b] mt-0.5">
            Trilha de operações do super-painel (logins, mudanças em servidores, contas, super-admins).
          </p>
        </div>
      </div>

      <div className="max-w-[300px]">
        <Input
          placeholder="Filtrar por ação (ex: conta.suspended)"
          value={actionFilter}
          onChange={(e) => setActionFilter(e.target.value)}
        />
      </div>

      <Card>
        <div className="overflow-auto max-h-[520px]">
          <table className="w-full text-sm min-w-[800px]">
            <thead className="sticky top-0 z-10 bg-[#fafafa]">
              <tr className="border-b border-[#e2e8f0]">
                <th className="px-4 py-3 text-left font-semibold text-[#374151] whitespace-nowrap">Quando</th>
                <th className="px-4 py-3 text-left font-semibold text-[#374151] whitespace-nowrap">Ação</th>
                <th className="px-4 py-3 text-left font-semibold text-[#374151] whitespace-nowrap">User</th>
                <th className="px-4 py-3 text-left font-semibold text-[#374151] whitespace-nowrap">Server</th>
                <th className="px-4 py-3 text-left font-semibold text-[#374151] whitespace-nowrap">IP</th>
                <th className="px-4 py-3 text-left font-semibold text-[#374151] whitespace-nowrap">Payload</th>
              </tr>
            </thead>
            <tbody>
              {auditQuery.isLoading && (
                <tr>
                  <td colSpan={6} className="px-4 py-12 text-center text-sm text-[#94a3b8]">
                    Carregando...
                  </td>
                </tr>
              )}
              {auditQuery.data?.length === 0 && (
                <tr>
                  <td colSpan={6} className="px-4 py-12 text-center text-sm text-[#94a3b8]">
                    Sem entradas no log.
                  </td>
                </tr>
              )}
              {auditQuery.data?.map((e) => (
                <tr
                  key={e.id}
                  className="group border-b border-[#f1f5f9] last:border-0 hover:bg-[#f8fafc] transition-colors align-top"
                >
                  <td className="px-4 py-3.5 text-xs font-mono text-[#64748b] whitespace-nowrap">
                    {new Date(e.created_at).toLocaleString('pt-BR')}
                  </td>
                  <td className="px-4 py-3.5">
                    <span className="inline-flex px-2 py-0.5 rounded text-xs font-medium font-mono bg-[#eff4ff] text-[#0a4ee3]">
                      {e.action}
                    </span>
                  </td>
                  <td className="px-4 py-3.5 text-xs text-[#0f172a]">
                    {e.email ?? (e.super_user_id ? `#${e.super_user_id}` : '—')}
                  </td>
                  <td className="px-4 py-3.5 text-xs text-[#64748b]">
                    {e.server_id ? `#${e.server_id}` : '—'}
                  </td>
                  <td className="px-4 py-3.5 text-xs font-mono text-[#94a3b8] whitespace-nowrap">
                    {e.ip_address ?? '—'}
                  </td>
                  <td className="px-4 py-3.5 text-xs">
                    {e.payload && Object.keys(e.payload).length > 0 ? (
                      <pre className="font-mono text-[#64748b] whitespace-pre-wrap break-all max-w-[400px]">
                        {JSON.stringify(e.payload, null, 2)}
                      </pre>
                    ) : (
                      <span className="text-[#cbd5e1]">—</span>
                    )}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </Card>
    </div>
  );
}
